import React, { useState, useEffect, useRef } from 'react';
import { Modal, Typography, List, Button, Space, Checkbox, Input, Upload, Spin, Form } from 'antd'
import {
    CarOutlined
} from "@ant-design/icons";
const { Text } = Typography;
import { generateInspectionRequest } from '../utils/apiService';
import PhoneInput from 'antd-phone-input';


const InspectionRequestModal = ({ open, setOpen, data, selectedId, reload, success, fail }) => {

    const [comments, setComments] = useState([]);
    const [vehicle, setVehicle] = useState([]);
    const [images, setImages] = useState([]);
    const [selectedComments, setSelectedComments] = useState([]);
    const [note, setNote] = useState('');
    const [controllerName, setControllerName] = useState('');
    const [controllerNumber, setControllerNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const formRef = useRef(null);




    useEffect(() => {
        setIsLoading(true);
    }, []);

    useEffect(() => {
        if (!data || !open) return;

        const itemComments = data.itemComments ?? [];
        const itemImages = data.images ?? [];

        setComments(itemComments);
        setVehicle(data.vehicle);
        setImages(itemImages);

        setSelectedComments(
            itemComments.map(item => ({
                ...item,
                images: itemImages.filter(img => img.blobPath.includes(item.itemId))
            }))
        );

        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, [data, open]);



    useEffect(() => {
        if (!open) {
            form.resetFields();
            setComments([]);
            setVehicle({});
            setImages([]);
            setControllerName('');
            setControllerNumber('');
            setSelectedComments([]);
            setNote('');
        }
    }, [open]);



    const toggleSelect = (item) => {
        // get images for this comment
        const itemImages = images.filter(img => img.blobPath.includes(item.itemId));

        setSelectedComments(prev => {
            const exists = prev.some(x => x.title === item.title && x.comment === item.comment);
            if (exists) {
                // remove if already selected
                return prev.filter(x => !(x.title === item.title && x.comment === item.comment));
            }
            // add with images
            return [...prev, { ...item, images: itemImages }];
        });
    };

    const generateRequest = async (data) => {
        try {
            setIsLoading(true);
            await generateInspectionRequest(data);
            success();
        } catch (error) {
            console.log(`Couldnt generate request : ${error}`)
            fail();
        } finally {

            setOpen(false);
            setIsLoading(false);
            reload();
        }
    }

    return (
        <Modal className="inspection-modal" title='Event' open={open} setOpen={setOpen} onCancel={() => setOpen(false)} footer={
            <Space>
                <Button
                    icon={<CarOutlined />}
                    type="primary"
                    disabled={isLoading}
                    loading={isLoading} onClick={async () => {

                        try {
                            await form.validateFields();

                            const phone = controllerNumber
                                ? `+${controllerNumber.countryCode}${controllerNumber.areaCode}${controllerNumber.phoneNumber}`
                                : null;

                            const payLoad = {
                                selectedComments,
                                vehicle,
                                note,
                                selectedId,
                                controllerName,
                                controllerNumber: phone,
                            };

                            await generateRequest(payLoad);


                        } catch (err) {
                            const firstErrorField = document.querySelector('.ant-form-item-has-error');
                            if (firstErrorField) {
                                firstErrorField.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                });
                            }
                        }
                    }}
                >
                    Create Event
                </Button>
            </Space>
        } bodyStyle={{ maxHeight: '75vh', overflowY: 'auto' }}>

            <Spin spinning={isLoading}>
                <br />
                <Text strong> Vehicle Details</Text>
                <br />
                <div style={{ height: '10px' }}></div>
                <Text type="secondary">
                    Registration: {vehicle?.registration || "N/A"}
                </Text>
                <br />
                <Text type="secondary">
                    Fleet: {vehicle?.fleet || "N/A"}
                </Text>
                <br />
                <Text type="secondary">
                    Make: {vehicle?.make || "N/A"}
                </Text>
                <br />
                <Text type="secondary">
                    Model: {vehicle?.model || "N/A"}
                </Text>
                <br />
                <Text type="secondary">
                    Year: {vehicle?.year || "N/A"}
                </Text>
                <br />
                <Text type="secondary">
                    Vin: {vehicle?.vin || "N/A"}
                </Text>
                <br />
                <Text type="secondary">
                    Current Hours: {vehicle?.CurrentHours || "N/A"}
                </Text>
                <br />
                <Text type="secondary">
                    Current Km: {vehicle?.currentKm || "N/A"}
                </Text>
                <br />
                <br />
                <div style={{ height: '10px' }}></div>


                <div style={{ height: '10px' }}></div>

                <Form form={form} ref={formRef} layout="vertical" >
                    <Form.Item
                        name="controllerName"
                        label="Controller Name"
                        rules={[{ required: true, message: 'Please enter controller name' }]}
                    >
                        <Input
                            placeholder="Controller Name"
                            value={controllerName}
                            onChange={(e) => {
                                const value = e.target.value;
                                setControllerName(value);
                                form.setFieldsValue({ controllerName: value });
                            }} />                    </Form.Item>

                    <Form.Item
                        name="controllerNumber"
                        label="Phone Number"
                        rules={[
                            {
                                required: true,
                                validator: (_, value) =>
                                    value && value.valid()
                                        ? Promise.resolve()
                                        : Promise.reject('Invalid phone number'),
                            },
                        ]}

                    >
                        <PhoneInput
                            enableSearch
                            value={controllerNumber}
                            onChange={(value) => {
                                setControllerNumber(value);
                                form.setFieldsValue({ controllerNumber: value });
                            }}
                        />                    </Form.Item>

                    <Form.Item
                        name="notes"
                        label="Other Notes"
                    >
                        <Input
                            placeholder="Other Notes"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                        />                    </Form.Item>
                </Form>


                <br />

                <div style={{ height: '10px' }}></div>


                <Text strong>Selected Items for event</Text>
                <div style={{ height: '10px' }}></div>

                <div>
                    <List
                        dataSource={comments}
                        rowKey={(_, i) => i}
                        renderItem={(item, index) => {
                            const checked = selectedComments.some(
                                x => x.title === item.title && x.comment === item.comment
                            );

                            // filter images for this item
                            const itemImages = images.filter(img =>
                                img.blobPath.includes(item.itemId)
                            );

                            return (
                                <List.Item
                                    key={index}
                                    style={{ cursor: 'pointer', flexDirection: 'column', alignItems: 'flex-start', opacity: checked ? 1 : 0.5 }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, width: '100%' }}>
                                        <Checkbox
                                            checked={checked}
                                            onClick={e => e.stopPropagation()}
                                            onChange={() => toggleSelect(item)}
                                            className={!checked ? 'unchecked-checkbox' : ''}

                                        />
                                        <div>
                                            <Text strong>{item.title}</Text><br />
                                            <Text type="secondary">{item.comment}</Text>
                                        </div>
                                    </div>
                                    {itemImages.length > 0 && (
                                        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                                            <Upload
                                                listType="picture-card"
                                                multiple
                                                beforeUpload={() => false}
                                                showUploadList={{ showRemoveIcon: false }}
                                                fileList={itemImages.map((img, idx) => ({
                                                    uid: img.blobPath || idx,
                                                    name: img.blobPath?.split('/').pop() || `Image-${idx}`,
                                                    url: img.blobUrl,
                                                    isServer: true
                                                }))}
                                                onChange={({ fileList }) => {
                                                    // optional: if you want to allow changes per comment
                                                    // You can update images state for this item here
                                                }}
                                            >
                                            </Upload>
                                        </div>
                                    )}

                                </List.Item>
                            );
                        }}
                    />

                </div>
                <div style={{ height: '10px' }}></div>
                <br />




            </Spin>

        </Modal>);
}

export default InspectionRequestModal;